<template>
  <div>
    <section>
      <div class="row">
        <div class="small-12 columns">
          <h2 class="section-sub-heading">Your employment contributions</h2>
        </div>
      </div>

      <employment-inputs></employment-inputs>

      <hr />

      <div class="row">
        <div class="small-12 columns">
          <h2 class="section-sub-heading">Your current super account balances</h2>
        </div>
      </div>

      <balance-inputs></balance-inputs>

      <div class="spouse" v-show="IncludePartner.value">
        <hr />

        <div class="row">
          <div class="small-12 columns">
            <h2 class="section-sub-heading">Your partner's employment contributions</h2>
          </div>
        </div>

        <employment-inputs :modifier="partnerModifier"></employment-inputs>

        <hr />

        <div class="row">
          <div class="small-12 columns">
            <h2 class="section-sub-heading">Your partner's current super account balances</h2>
          </div>
        </div>

        <balance-inputs :modifier="partnerModifier"></balance-inputs>
      </div>
    </section>

    <div v-if="!hideNav">
      <hr />
      <div class="page-actions">
        <router-link class="button" :to="{name: 'about.personal'}">&larr; Back</router-link>
        <router-link class="button" :to="{name: 'about.retirement'}">Next &rarr;</router-link>

        <!-- <div class="skip">
          <router-link :to="{name: 'results'}">Skip to see results</router-link>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { Constants } from '@/constants';

export default {
  props: ['hide-nav'],
  components: {
    BalanceInputs: require('../../inputs/BalanceInputs').default,
    EmploymentInputs: require('../../inputs/EmploymentInputs').default,
  },
  data() {
    return {
      partnerModifier: Constants.PARAMETER_PARTNER_SUFFIX,
    };
  },
  computed: {
    ...mapState(['inputs']),
    IncludePartner() {
      return this.inputs.IncludePartner;
    },
  },
};
</script>
